export default "__VITE_ASSET__BWjp0RFE__"